import { LoadingButton } from '@mui/lab';

import { Grid } from '@mui/material';

import { Field, Form } from '@shared/form';

import { createView } from '@shared/lib/view';

import { completeLoginFx, form, reset } from './model';

const $loading = completeLoginFx.pending;
const $$fields = form.fields;

const ConfirmLoginByMFAForm = createView()
  .units({ loading: $loading })

  .close(reset)

  .view(({ loading }) => (
    <Form
      use={form}
      renderForm={({ onSubmit, onReset, children }) => (
        <Grid
          container
          item
          component='form'
          flexDirection='column'
          alignItems='center'
          justifyContent='space-between'
          onSubmit={onSubmit}
          onReset={onReset}
          flex={1}
        >
          {children}
        </Grid>
      )}
    >
      <Grid
        item
        container
        flexDirection='column'
        justifyContent='center'
        gap={3}
        flex={1}
      >
        <Field.Number
          field={$$fields.code}
          label='Verification code'
          maxLength={6}
          positive
        />

        <LoadingButton
          type='submit'
          variant='contained'
          loading={loading}
          fullWidth
        >
          Confirm MFA
        </LoadingButton>
      </Grid>
    </Form>
  ));

export { ConfirmLoginByMFAForm };
